import StoryblokClient from 'storyblok-js-client'
import { get } from 'lodash'

const Storyblok = new StoryblokClient({
  accessToken: process.env.STORYBLOK_PUBLIC_TOKEN,
})

// NOTE: Add RichTextField nestable components here.
// https://www.storyblok.com/docs/richtext-field#javascript-sdk
Storyblok.setComponentResolver((componentName, blok) => {
  switch (componentName) {
    case 'globalPrice':
      // TODO: Refactor to use imported component fn convertReactComponentToHTMLString(blok.component)
      return `<div class="global-price pro ${get(blok, 'pro.isFeaturePrice') &&
        'is-feature-price'}">${get(blok, 'pro.price')}</div>`
    default:
      return 'Resolver not defined'
  }
})

export default Storyblok



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/services/storyblok.js